import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';

import { DelayTimer } from 'consts';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getNodeHeightCeil } from 'utils';

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/cards/Card.scss';

const Card = ({ cardState, className, children, onActivate, cardKey }) => {
  if (!children) {
    return null;
  }

  const { isActive = false, isNext = false, isPrevious = false } = cardState;
  const [activated, setActivated] = useState(false);
  let activateTimeout = null;

  const getActiveRefNode = () => activeRef ? activeRef.current : null;

  const onCardActivate = (node, isResize = false) => {
    activateTimeout = setTimeout(() => {
      isActive && node !== null && onActivate({ height: getNodeHeightCeil(node, 40), cardKey, isResize });
    }, DelayTimer.DeckRefreshHeightMS);
  };

  const onResize = () => {
    const refNode = getActiveRefNode();
    refNode && onCardActivate(refNode, true);
  };

  useLayoutEffect(() => {
    window.addEventListener('resize', onResize, { passive: true });

    //componentWillUnmount
    return () => {
      activateTimeout && clearTimeout(activateTimeout);
      window.removeEventListener('resize', onResize);
    }
  }, []);

  //
  useEffect(() => setActivated(isActive), [cardState]);

  // componentDidUpdate activated && cardState.isActive, setting activeRef
  const activeRef = useCallback((node) => {
    isActive && !activated && onCardActivate(node);
  }, [activated, cardState]);

  return (
    <div className={classNames('csw-card', className, cardKey, {
      'csw-active': isActive,
      'csw-inactive': !isActive,
      'csw-next': isNext,
      'csw-previous': isPrevious,
    })}
         ref={isActive ? activeRef : null}
         aria-hidden={!isActive}>
      {children}
    </div>
  );
};

Card.propTypes /* remove-proptypes */ = {
  cardState: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.object,
  onActivate: PropTypes.func.isRequired,
  cardKey: PropTypes.string.isRequired
};

export default Card;
